import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { courseActions } from './../../features/course/course.actions'
import { productActions } from './../../features/product/product.actions'
import { map, withLatestFrom } from 'rxjs/operators'
import { combineLatest, Observable } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { cartItemSelectors } from 'src/app/features/cart/cart-item/cart-item.selectors'
import { CartItemService } from 'src/app/features/cart/cart-item/cart-item.service'
import { Product } from 'src/app/features/product/product'
import { productSelectors } from 'src/app/features/product/product.selectors'
import { Component, OnInit } from '@angular/core'
import { Dictionary } from '@ngrx/entity'
import { Store } from '@ngrx/store'
import { CartItem } from '../../features/cart/cart-item/cart-item'
import { Subscription } from 'src/app/features/subscription/subscription'
import { Course } from 'src/app/features/course/course'
import { subscriptionSelectors } from 'src/app/features/subscription/subscription.selectors'
import { courseSelectors } from 'src/app/features/course/course.selectors'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import moment from 'moment-mini'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { ConfigurationService } from 'src/app/shared/services/configuration.service'
import { Router } from '@angular/router'
import { AppRoutesNS } from 'src/app/app-routes.namespace'
@UntilDestroy()
@Component({
  selector: 'cart-block',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class CartBlockComponent implements OnInit {
  public cartItems$: Observable<CartItem[]>
  public cartItemsUnauthenticated$: Observable<Partial<CartItem>[]>
  public cartItemsTotal$: Observable<number>
  public cartItemsTotalUnauthenticated$: Observable<number[]>
  public cartItemCount$: Observable<number>
  public cartItemCountUnauthenticated$: Observable<number>
  public productEntities$: Observable<Dictionary<Product>>
  public productEntities: Dictionary<Product>
  public subscriptionEntities$: Observable<Dictionary<Subscription>>
  public courseEntities$: Observable<Dictionary<Course>>
  public courseEntities: Dictionary<Course>
  public selectedLanguage$: Observable<string>
  public chargeData$: Observable<any>
  public cartItemBasePrices = {}
  private calledIds = []
  constructor(
    private store: Store<AppState>,
    public cartItemService: CartItemService,
    public configurationService: ConfigurationService,
    public router: Router
  ) {}

  ngOnInit() {
    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )
    this.productEntities$ = this.store.select(productSelectors.selectEntities)
    this.cartItems$ = this.store.select(cartItemSelectors.selectAll)
    this.cartItemsUnauthenticated$ = this.store.select(
      cartItemSelectors.selectPartials
    )
    this.cartItemsTotal$ = this.cartItemService.getCartItemsTotal$()

    this.cartItemCount$ = this.store.select(cartItemSelectors.selectCount)
    this.cartItemCountUnauthenticated$ = this.store.select(
      cartItemSelectors.selectCountUnauthenticated
    )
    this.subscriptionEntities$ = this.store.select(
      subscriptionSelectors.selectEntities
    )
    this.courseEntities$ = this.store.select(courseSelectors.selectEntities)

    combineLatest([this.cartItemsUnauthenticated$])
      .pipe(
        map((cartItemsUnauthenticated) => {
          return cartItemsUnauthenticated.map((itemsArray) => {
            return itemsArray.map((items) => {
              if (items.courseId) {
                return items.courseId
              } else if (items.productId) {
                if (this.calledIds.includes(items.productId)) {
                  return items
                }
                this.calledIds.push(items.productId)
                this.store.dispatch(
                  productActions.fetchMany({
                    params: RequestQueryBuilder.create({
                      search: {
                        $and: [
                          {
                            $or: [
                              {
                                isCourse: 0
                              },
                              {
                                isCourse: null
                              }
                            ]
                          },
                          {
                            $or: [
                              {
                                availableTillDate: {
                                  [CondOperator.GREATER_THAN_EQUALS]:
                                    moment().toISOString()
                                }
                              },
                              {
                                availableTillDate: null
                              }
                            ]
                          },
                          {
                            allowAsLinkedProduct: 0
                          },
                          {
                            bookable: 0
                          },
                          {
                            isRental: 0
                          },
                          { isActive: true },
                          {
                            availableFromDate: {
                              [CondOperator.LOWER_THAN_EQUALS]:
                                moment().toISOString()
                            }
                          }
                        ]
                      },
                      join: [
                        { field: 'tags' },
                        { field: 'translations' },
                        { field: 'documents' }
                      ]
                    })
                  })
                )
                return items
              }
            })
          })
        }),
        map((courseIds) => [...new Set(courseIds[0])]),
        map((courseToFetch) => {
          courseToFetch.map((id) => {
            if (typeof id != 'number') {
              return
            }
            this.store.dispatch(courseActions.fetchOneById({ id: id }))
          })
        })
      )
      .subscribe()

    this.store
      .select(cartItemSelectors.selectAll)
      .pipe(untilDestroyed(this), withLatestFrom(this.productEntities$))
      .subscribe(([cartItems, productEntities]) => {
        const didChargeBasePriceResourceProductIds: string[] = []

        if (!productEntities) {
          return
        }
        this.cartItemBasePrices = []
        for (const cartItem of cartItems) {
          const product =
            productEntities[
              cartItem?.params?.bookableLinkedProductId ??
                cartItem?.params?.bookableProductId
            ]

          const basePriceKey = `${cartItem?.params?.startDate}-${cartItem?.params?.bookableProductId}`

          if (
            product &&
            product.allowAsLinkedProduct &&
            product.allowChooseCategory &&
            product.basePrice &&
            cartItem.params?.bookableProductId &&
            !didChargeBasePriceResourceProductIds.includes(basePriceKey)
          ) {
            didChargeBasePriceResourceProductIds.push(basePriceKey)
            this.cartItemBasePrices[
              `${cartItem?.id}-${cartItem?.params?.startDate}-${cartItem?.params?.bookableProductId}`
            ] = product.basePrice
          }
        }
      })
  }
  public navigateToCart() {
    this.router.navigate([AppRoutesNS.Cart.CART])
  }
  public getCartItemBasePrice(cartItem: CartItem) {
    if (!cartItem || !cartItem.params?.bookableProductId) {
      return 0
    }

    const key = `${cartItem?.id}-${cartItem?.params?.startDate}-${cartItem.params?.bookableProductId}`

    if (this.cartItemBasePrices[key]) {
      return this.cartItemBasePrices[key]
    }
    return 0
  }

  public showCartInMobile$(): Observable<boolean> {
    return this.configurationService.isRouteAllowedOnMobileApp$(
      AppRoutesNS.Cart.CART
    )
  }
}
